import _ from "lodash";
import { mapActions, mapGetters } from "vuex";

/* Create mapActions and mapGetters for a RestModule (and similar modules)
for Code Modules. And loads them!

moduleList is an array of Module names but assume moduleList has the value
['Test']

Then the following actions and getters are created

mapActions({
    createNewTest: 'TestModule/createNew',
    saveTestItem: 'TestModule/saveItem',
    getTestById: 'TestModule/getById',
    patchTestItem: 'TestModule/pathItem',

    getAllTest: 'TestModule/getAll', //called by loadCodeTables and when created
});

mapGetters({
    optionTestItems: 'TestModule/code_items',
    optionTestItems: 'TestModule/code_itemsByID',
    optionTestWorking: 'TestModule/working',
    optionTestItemsById: 'TestModule/itemsByID',
});
 */

export default function (moduleList) {
    var actionList = {};
    var fetchActionList = {};
    var getterList = {};

    _.each(moduleList, function (moduleName) {
        actionList["createNew" + moduleName] = moduleName + "Module/createNew";
        actionList["save" + moduleName + "Item"] =
            moduleName + "Module/saveItem";
        actionList["get" + moduleName + "ById"] = moduleName + "Module/getById";
        actionList["patch" + moduleName + "Item"] =
            moduleName + "Module/patchItem";

        fetchActionList["getAll" + moduleName] = moduleName + "Module/getAll";

        getterList["option" + moduleName + "Items"] =
            moduleName + "Module/code_items";
        getterList["option" + moduleName + "ItemsById"] =
            moduleName + "Module/code_itemsByID";
        getterList["option" + moduleName + "Working"] =
            moduleName + "Module/working";
        getterList["get" + moduleName + "NewItem"] = moduleName + "Module/item";
    });

    /* With a Module name of "Customer" create a Method GetCustomerCodeList(list_options)
       That can be called to load the code options
     */

    var getCodeTablesMethods = {};
    _.each(moduleList, function (moduleName) {
        var function_name = "Get" + moduleName + "CodeList";

        getCodeTablesMethods[function_name] = function (list_options) {
            var vm = this;

            list_options = {
                ...{
                    limit: 2000,
                    offset: 0,
                    _code: true,
                },
                ...list_options,
            }; // Get 2000 items - should be all if not we need to use another method
            vm["getAll" + moduleName]({ ...list_options });
        };
    });

    return {
        methods: {
            ...getCodeTablesMethods,
            loadCodeTables() {
                const vm = this;
                // Load all
                _.each(moduleList, function (moduleName) {
                    vm["Get" + moduleName + "CodeList"]();
                });
            },
            ...mapActions({ ...fetchActionList, ...actionList }),
        },
        computed: {
            ...mapGetters(getterList),
        },
        created() {
            this.loadCodeTables();
        },
    };
}
